import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./custom.css"; // Import the custom CSS file
import config from "../../config";
import fetchWithAuth from '../../services/fetchWithAuth';  

const RegistrationPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    document.title = "MamFam Registration";
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const baseUrl = config.API_BASE_URL;
      const endpoint = "register/";
      const response = await fetchWithAuth(`${baseUrl}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password, firstName, lastName }),
      });

      if (response.ok) {
        setIsSuccess(true);
        setShowModal(true);
      } else {
        const errorData = await response.json();
        setError(errorData.detail || "Registration failed");
        setIsSuccess(false);
        setShowModal(true);
      }
    } catch (error) {
      setError("An error occurred. Please try again.");
      setIsSuccess(false);
      setShowModal(true);
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-6 offset-md-3">
          <div className="card">
            <div className="card-body">
              <h2 className="card-title">Registration</h2>
              {!isSuccess && (
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="inputEmail" className="form-label">
                      Email<span className="text-danger">*</span>:
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="inputEmail"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="inputPassword" className="form-label">
                      Password<span className="text-danger">*</span>:
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="inputPassword"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="inputFirstName" className="form-label">
                      First Name:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="inputFirstName"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="inputLastName" className="form-label">
                      Last Name:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="inputLastName"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>
                  {error && <p className="text-danger">{error}</p>}
                  <button type="submit" className="btn btn-primary">
                    Register
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
      >
        <div className="modal-dialog custom-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{isSuccess ? "Success" : "Error"}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              {isSuccess ? (
                <p>Registration successful! You can now login.</p>
              ) : (
                <p>{error}</p>
              )}
            </div>
            <div className="modal-footer">
              {isSuccess ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => (window.location.href = "/login")}
                >
                  Go to Login
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal-backdrop fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
      ></div>
    </div>
  );
};

export default RegistrationPage;
